import { render, staticRenderFns } from "./IcoCompetencyLibrary.vue?vue&type=template&id=d9ebbda8"
import script from "./IcoCompetencyLibrary.vue?vue&type=script&lang=js"
export * from "./IcoCompetencyLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports